 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bfe2e80042427a1596a717435a77b0132d19ef8d","1":"985ead4ebad2bbd08cf336b12832f63c05b62dd4","6":"component---packages-bento-build-readme-md","7":"component---packages-bento-icons-build-readme-md","8":"component---packages-bento-icons-readme-md","9":"component---packages-bento-lib-components-badge-badge-mdx","10":"component---packages-bento-lib-components-button-button-mdx","11":"component---packages-bento-lib-components-callout-callout-mdx","12":"component---packages-bento-lib-components-counter-counter-mdx","13":"component---packages-bento-lib-components-divider-divider-mdx","14":"component---packages-bento-lib-components-form-field-mdx","15":"component---packages-bento-lib-components-form-textarea-mdx","16":"component---packages-bento-lib-components-loaders-dots-mdx","17":"component---packages-bento-lib-components-loaders-spinner-mdx","18":"component---packages-bento-lib-components-modal-modal-mdx","19":"component---packages-bento-lib-components-rating-rating-mdx","20":"component---packages-bento-lib-components-read-more-readmore-mdx","21":"component---packages-bento-lib-components-spacing-spacer-mdx","22":"component---packages-bento-lib-components-stencil-stencil-mdx","23":"component---packages-bento-lib-components-truncate-truncate-mdx","24":"component---packages-bento-lib-scss-generators-background-background-mdx","25":"component---packages-bento-lib-scss-generators-border-border-mdx","26":"component---packages-bento-lib-scss-generators-box-shadow-box-shadow-mdx","27":"component---packages-bento-lib-scss-generators-box-sizing-box-sizing-mdx","28":"component---packages-bento-lib-scss-generators-color-color-mdx","29":"component---packages-bento-lib-scss-generators-cursor-cursor-mdx","30":"component---packages-bento-lib-scss-generators-dimension-dimension-mdx","31":"component---packages-bento-lib-scss-generators-display-display-mdx","32":"component---packages-bento-lib-scss-generators-flex-flex-mdx","33":"component---packages-bento-lib-scss-generators-float-float-mdx","34":"component---packages-bento-lib-scss-generators-grid-grid-mdx","35":"component---packages-bento-lib-scss-generators-opacity-opacity-mdx","36":"component---packages-bento-lib-scss-generators-overflow-overflow-mdx","37":"component---packages-bento-lib-scss-generators-position-position-mdx","38":"component---packages-bento-lib-scss-generators-spacing-spacing-mdx","39":"component---packages-bento-lib-scss-generators-typography-typography-mdx","40":"component---packages-bento-lib-scss-generators-visibility-visibilty-mdx","41":"component---packages-bento-lib-scss-generators-z-index-z-index-mdx","42":"component---packages-bento-readme-md","43":"component---readme-md","44":"component---src-gatsby-theme-docz-pages-docs-icon-library-icons-mdx","45":"component---src-gatsby-theme-docz-pages-docs-icon-library-logos-mdx","46":"component---src-gatsby-theme-docz-pages-docs-tokens-colors-mdx","47":"component---src-gatsby-theme-docz-pages-docs-tokens-grid-mdx","48":"component---src-gatsby-theme-docz-pages-docs-tokens-media-mdx","49":"component---src-gatsby-theme-docz-pages-docs-tokens-spacing-mdx","50":"component---src-gatsby-theme-docz-pages-docs-tokens-typography-mdx","51":"component---src-pages-404-js","52":"component---src-pages-index-js"}[chunkId]||chunkId) + "-" + {"0":"49d634fa9c2f2f8bb271","1":"5c4327a38fc2338b0cd4","6":"cb829ea60f62b0562638","7":"bbc316a0291f97d96b1d","8":"272e9d99d0b01886629f","9":"282dc86d2a3c77cd3ce7","10":"a5d0afec1232012a2f24","11":"e34d1566469c7cbaea2a","12":"7d223b7589aff76be48f","13":"67d30fc320069e3098e0","14":"686bcf452f36c178cc51","15":"93ef431cda349a505679","16":"add20232a0b1ab4ead40","17":"a7cb3c7cda836f1c4161","18":"bae6d2704a90bc515e77","19":"181e7fa1ce319b615a9c","20":"3c31bd8fe078f5fa16c7","21":"a38f0c72a9d38279e949","22":"7c6454341a51574ee9fe","23":"071ad1cc4579810c012c","24":"be2db1d34c237aa71c2a","25":"9a7f65bde69511bed4de","26":"1ea1fb6688a11e48b03c","27":"f0dd31e787d6884a2d24","28":"e5a0ee86fab24ec554fc","29":"dc26d7e69332bd209ce5","30":"b0741bf1ead2394709a5","31":"e77ee4629c3e3fa21716","32":"7cb7f7c7c4d0c9c108a1","33":"22e824dd9f00fd91c639","34":"945b8e74711c68df498c","35":"fa8e3ab4fafffd81549d","36":"9feeb9d80dbd7841d5c6","37":"e9f44381d93b8a63e07e","38":"813d27f73a55d9183a8d","39":"fbac6b8a63c7c5c3ab96","40":"648e053b21de01e4c8ff","41":"53acf2e26501501e77f4","42":"2c46fe16d0af9751c315","43":"8feec10f4e59951079af","44":"f29ca5246124a6d70493","45":"406747767efc046b3f97","46":"fd4d6383958788984612","47":"5ca94eb97139047477b4","48":"e127448cb43ed5fd8846","49":"b2562a8e6e8e30e6e065","50":"42119420fbb542765452","51":"e93192c70019a36de5eb","52":"cc6b8d9509f4ab0f95d9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
